import { RegisterClass } from "core/Misc/typeStore";
import { Vector3 } from "core/Maths/math.vector";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphBuildState } from "../rewardGraphBuildState";

export class RewardPowBlock extends RewardGraphNode {
    public constructor(name: string) {
        super(name);

        this.registerInput("input", RewardGraphConnectionPointTypes.AutoDetect);
        this.registerInput("exponent", RewardGraphConnectionPointTypes.Float);
        this.registerOutput("output", RewardGraphConnectionPointTypes.BasedOnInput);

        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push(RewardGraphConnectionPointTypes.Quat);
        this._inputs[0].excludedConnectionPointTypes.push(RewardGraphConnectionPointTypes.PartID);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardPowBlock";
    }

    /**
     * Gets the input component
     */
    public get input(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    public get exponent(): RewardGraphConnectionPoint {
        return this._inputs[1];
    }

    /**
     * Gets the output component
     */
    public get output(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock(state: RewardGraphBuildState) {
        super._buildBlock(state);

        if (!this.input.isConnected || !this.exponent.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }

        switch (this.input.type) {
            case RewardGraphConnectionPointTypes.Float: {
                this.output._storedFunction = (state) => {
                    const base = this.input.getConnectedValue(state);
                    const exp = this.exponent.getConnectedValue(state);
                    return Math.pow(base, exp);
                };
                break;
            }
            case RewardGraphConnectionPointTypes.Vector3: {
                this.output._storedFunction = (state) => {
                    const base = this.input.getConnectedValue(state);
                    const exp = this.exponent.getConnectedValue(state);
                    return new Vector3(Math.pow(base.x, exp), Math.pow(base.y, exp), Math.pow(base.z, exp));
                };
                break;
            }
        }

        return this;
    }

}

RegisterClass("MELS.RewardPowBlock", RewardPowBlock);